/**
 * Lightbox-Caption-Bridge für fslightbox
 *
 * fslightbox (Free) zeigt Bildunterschriften nicht out-of-the-box. Wir injizieren
 * einen Caption-Container, der den Untertitel der aktuell sichtbaren Slide anzeigt.
 *
 * Robust gegen fslightbox-Interna:
 *  - Aktive Slide wird über die GERENDERTE Bildposition erkannt (fslightbox legt
 *    Slides nebeneinander und schiebt sie per translateX; die aktive ist im
 *    Viewport zentriert) — kein Verlass auf interne CSS-Klassen/Display-States.
 *  - Caption kommt primär aus einer URL→Caption-Map der Source-Links
 *    (`a[data-fslightbox][data-caption]`), Fallback: `data-caption` am Slide-<img>.
 *  - Quelle der Caption: Datei-Metadaten (im Galerie-Template als data-caption gesetzt).
 */

import "fslightbox";

const captionStyle = {
  position: "absolute",
  bottom: "1.25rem",
  left: "50%",
  transform: "translateX(-50%)",
  background: "rgba(0, 0, 0, 0.7)",
  color: "#fff",
  padding: "0.5rem 1rem",
  borderRadius: "0.5rem",
  maxWidth: "90%",
  textAlign: "center",
  zIndex: "10000",
  fontSize: "1rem",
  lineHeight: "1.4",
  pointerEvents: "none",
};

let captionBox = null;

/** URL (absolut) → Caption aus allen Galerie-Source-Links sammeln. */
function buildSrcCaptionMap() {
  const map = new Map();
  document.querySelectorAll("a[data-fslightbox]").forEach((a) => {
    const cap = (a.getAttribute("data-caption") || "").trim();
    // a.href ist bereits absolutiert — matcht das src des Lightbox-<img>.
    if (cap) map.set(a.href, cap);
  });
  return map;
}

/** Die aktuell sichtbare Slide = das Source-<img>, dessen Mitte dem Viewport-Zentrum am nächsten ist. */
function findActiveImage(container) {
  let activeImg = null;
  let best = Infinity;
  const centerTarget = window.innerWidth / 2;
  container.querySelectorAll("img.fslightbox-source").forEach((img) => {
    const r = img.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return; // noch nicht gelayoutet
    const dist = Math.abs(r.left + r.width / 2 - centerTarget);
    if (dist < best) {
      best = dist;
      activeImg = img;
    }
  });
  return activeImg;
}

function updateCaption(map) {
  const container = document.querySelector(".fslightbox-container");
  if (!container) {
    if (captionBox) captionBox.style.display = "none";
    return;
  }

  const activeImg = findActiveImage(container);
  if (!activeImg) return;

  const caption =
    map.get(activeImg.src) ||
    (activeImg.getAttribute("data-caption") || "").trim() ||
    "";

  if (!captionBox) {
    captionBox = document.createElement("div");
    captionBox.className = "fslightbox-caption";
    Object.assign(captionBox.style, captionStyle);
  }
  // Container wird bei jedem Öffnen neu erzeugt → Box ggf. neu einhängen.
  if (captionBox.parentNode !== container) container.appendChild(captionBox);

  captionBox.textContent = caption;
  captionBox.style.display = caption ? "block" : "none";
}

export function init() {
  if (!document.querySelector("[data-fslightbox]")) return;
  const map = buildSrcCaptionMap();
  setInterval(() => updateCaption(map), 200);
}
